import LoginForm from "../../components/login-form";
import useDarkLibLayout from "../../components/loyauts/use-dark-lib-layout";

type Props = {}

const LoginPage: React.FC<Props> = () => {

    useDarkLibLayout();

    return <>
        <LoginForm />
    </>
}

export default LoginPage;
